import { Typography } from 'components';
import { PendingIcon, WarningIcon } from 'lib/svgs/Icons';
import { get } from 'lodash';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { dateTimeShort } from 'utils/time/dateTimeShort';
import { PurchaseOrderUnitary } from '../_context/useTableOrders';

interface IDescriptionOrder {
  purchaseOrder: PurchaseOrderUnitary;
}

const DescriptionOrder: FC<IDescriptionOrder> = ({ purchaseOrder }) => {
  const t = useTranslations();
  const description = get(purchaseOrder.orders, [0, 'translationRequest', 'title']);

  const paymentStatus = purchaseOrder.paymentStatus;
  const paymentSettled = paymentStatus === 'settled';
  const paymentNotApplicable = paymentStatus === 'na';
  const paymentPending = paymentStatus === 'pending';
  const paymentRequired = purchaseOrder.price > 0 && !(paymentSettled || paymentNotApplicable);

  const warningMessage = () => {
    if (paymentPending)
      return (
        <span className="flex items-center gap-1">
          <PendingIcon />
          <p className="font-size-body-small !m-0 !font-normal text-secondary-red">
            <span className="ticon-warning mr-05"></span>
            {t('billing.orders.index.pending_message')}
          </p>
        </span>
      );

    if (paymentRequired)
      return (
        <span className="flex items-center gap-1">
          <WarningIcon />
          <p className="font-size-body-small !m-0 !font-normal text-secondary-red">
            <span className="ticon-warning mr-05"></span>
            {t('billing.orders.index.retry_message')}
          </p>
        </span>
      );

    return null;
  };

  return (
    <Typography variant="regular4" className="select-none  text-tertiary-100">
      <p className="break-all !font-normal">{description}</p>
      <Typography variant="light5" className="text-tertiary-200">
        {dateTimeShort(purchaseOrder.createdAt)}
      </Typography>
      {warningMessage()}
    </Typography>
  );
};

export default DescriptionOrder;
